import React from "react";

const LinkedInIcon = () => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <g clipPath="url(#clip0_9071_9379)">
      <path
        fill="#999"
        d="M18.524 0H1.476A1.476 1.476 0 0 0 0 1.476v17.048A1.476 1.476 0 0 0 1.476 20h17.048A1.476 1.476 0 0 0 20 18.524V1.476A1.476 1.476 0 0 0 18.524 0M5.96 17.038H2.954V7.486h3.007zM4.456 6.163a1.726 1.726 0 1 1 1.736-1.726 1.7 1.7 0 0 1-1.736 1.725m12.588 10.883H14.04v-5.218c0-1.54-.654-2.014-1.499-2.014-.891 0-1.766.672-1.766 2.053v5.179H7.767V7.493h2.891v1.324h.04c.29-.588 1.306-1.592 2.858-1.592 1.677 0 3.49.996 3.49 3.912z"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_9071_9379">
        <path fill="#fff" d="M0 0h20v20H0z"></path>
      </clipPath>
    </defs>
  </svg>
  );
};

export default LinkedInIcon;
